// `?v=N` busts browser caches when the underlying asset is replaced —
// public/ files keep a stable URL, so bump the version on every swap.
export const AKEERA_AVATAR_SRC = '/images/akeera-avatar.png?v=2'

/**
 * Z-index ladder (documented here, used across the widget):
 * - launcher + panel: z-[9980] — above page chrome, deliberately BELOW
 *   InAppMeetingPanel (9999) so an active call pill is never hidden,
 *   and far below Radix dialogs (z-[999999]) so modals always win.
 * - tour dim/spotlight: z-[9990]; tour tooltip: z-[9991].
 */
export const HELP_WIDGET_Z = 'z-[9980]'
export const TOUR_OVERLAY_Z = 'z-[9990]'
export const TOUR_TOOLTIP_Z = 'z-[9991]'
